import { modelServicePost, modelServiceUpload } from '../../../../utils/modelService';
import { apiGet, apiPost, apiPatch, apiDelete } from '../../../../utils/api';

// Python model_service — scoring, extraction, AI pipeline
export const proxyInit = (body) => modelServicePost('/profitability/proxy-init', body);
export const extractDocument = (formData) => modelServiceUpload('/profitability/extract', formData);
// Focused single-variable extraction. Append `variable_key` to the FormData.
export const extractForVariable = (formData) => modelServiceUpload('/profitability/extract-for-variable', formData);
export const fetchMarketConditions = (body) => modelServicePost('/profitability/market-conditions', body);
export const estimateFinancial = (body) => modelServicePost('/profitability/estimate-financial', body);
export const calculateScore = (body) => modelServicePost('/profitability/score', body);
export const buildVelocityPlan = (body) => modelServicePost('/profitability/velocity-plan', body);
export const buildNarrative = (body) => modelServicePost('/profitability/narrative', body);

// Rails — persistence. Paths are relative to API_URL which already includes /api/v1.
export const listRuns = () => apiGet('/profitability/runs');
export const getRun = (id) => apiGet(`/profitability/runs/${id}`);
export const saveRun = (run) => apiPost('/profitability/runs', { run });
export const updateRun = (id, patch) => apiPatch(`/profitability/runs/${id}`, { run: patch });
export const deleteRun = (id) => apiDelete(`/profitability/runs/${id}`);
export const getPortfolio = () => apiGet('/profitability/runs/portfolio');
